// extracted by mini-css-extract-plugin
export default {"cards":"Welcome_cards__7TzPq","cardsMedium":"Welcome_cardsMedium__ZhGg-","cardsSmall":"Welcome_cardsSmall__UPSkE","linkStyle":"Welcome_linkStyle__USHrO"};